import React, { Fragment, useEffect } from "react";
import { Outlet } from "react-router-dom";
import { observer } from "mobx-react-lite";
import AppFrame from "./AppFrame";
import { useStore } from "../stores/store";
import { Loading } from "@shopify/polaris";
import LoginPage from "../../features/users/LoginPage";

const App = () => {
  const { commonStore, userStore } = useStore();

  useEffect(() => {
    if (commonStore.token) {
      userStore.getUser().finally(() => commonStore.setAppLoaded());
    } else {
      commonStore.setAppLoaded();
    }
  }, [commonStore, userStore])

  if (!commonStore.appLoaded) return (<Fragment><AppFrame><div style={{ height: '100px' }}><Loading /></div></AppFrame></Fragment>)

  if (!userStore.isLoggedIn) return (<Fragment><LoginPage /></Fragment>)

  return (
    <AppFrame>
      <Outlet />
    </AppFrame>
  )

};

export default observer(App);
